export default "__VITE_ASSET__D08Z5vHq__"